module.exports = __webpack_public_path__ + "static/media/rahul.6db11702.png";